const FALLBACK_APK = process.env.VUE_APP_GBLINK || '';

export default {
  data() {
    return {
      apk: FALLBACK_APK,
      versionApkMap: {},
    };
  },

  mounted() {
    // Keep the download target deterministic. The API may return a stale APK URL.
    this.apk = FALLBACK_APK;
  },

  methods: {
    getVersionApkUrl(versionItem) {
      const cached = this.versionApkMap[versionItem.version];
      if (cached) return Promise.resolve(cached);

      const fallbackKey = versionItem.apkFallback;
      const url = (fallbackKey && process.env[fallbackKey]) || FALLBACK_APK;

      this.versionApkMap[versionItem.version] = url;
      return Promise.resolve(url);
    },

    download() {
      const url = this.apk || FALLBACK_APK;
      if (url) {
        this.$global.download(url);
      }
    },

    downloadVersion(versionItem) {
      this.getVersionApkUrl(versionItem).then((url) => {
        if (url) this.$global.download(url);
      });
    },

    goTo(path) {
      this.$router.push(path);
    },
  },
};
